// FT-IMPORT Story 2 — provenance backlink for a Fast Track issue that was
// imported from a GitHub issue (issues.github_source, canonical "owner/repo#N").
// Display-only: renders "Imported from owner/repo#N" linking to the source
// issue on GitHub. Returns null when there's no (valid) source, so it's safe to
// drop into any header unconditionally. The loop-back-to-close-the-GitHub-issue
// is deliberately NOT built here (future work).

interface Props {
  githubSource?: string | null;
}

// Canonical S1 form: owner/repo#N (owner/repo have no spaces or '/'; N digits).
const SOURCE_RE = /^([^/\s]+)\/([^/\s#]+)#(\d+)$/;

export default function GithubSourceBacklink({ githubSource }: Props) {
  const match = githubSource?.match(SOURCE_RE);
  if (!match) return null;
  const [, owner, repo, number] = match;
  const href = `https://github.com/${owner}/${repo}/issues/${number}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="github-source-backlink"
      title={`Imported from ${owner}/${repo}#${number}`}
      style={{
        fontFamily: 'var(--font-body)',
        fontSize: 12,
        color: 'var(--text-secondary)',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      Imported from
      <span style={{ color: 'var(--primary)', textDecoration: 'underline' }}>{owner}/{repo}#{number}</span>
    </a>
  );
}
